import React, { ChangeEvent, useState } from 'react';
import { Typography, Popover, Box, FormControlLabel, Checkbox } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface FormFieldProps {
    label: string;
    infoText?: string;
    checked?: boolean;
    name?: string;
    handleCheckboxChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const CheckboxField: React.FC<FormFieldProps> = ({ label, infoText, handleCheckboxChange, checked, name}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event: any) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'info-popover' : undefined;

    return (
        <div style={{ display: 'flex', alignItems:'center' }}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={checked}
                        onChange={handleCheckboxChange}
                        name={name}
                        color="primary"
                    />
                }
                label={''}
            />
            <Typography><div><div style={{ fontWeight: 900 }}>{label}  {infoText && <InfoOutlinedIcon sx={{marginLeft:'10px', fontSize: '13px', cursor:'pointer'}} aria-describedby={id} onClick={handleClick} />}</div>
            </div></Typography>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ p: 1, maxWidth: 'auto' }}>
                    <Typography sx={{ fontSize: '12px' }}>{infoText}</Typography>
                </Box>
            </Popover>
        </div>
    );
};
